import React, { Component } from 'react';
import './App.css';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { BrowserRouter as Router, Route, Redirect, Link, Switch, HashRouter } from 'react-router-dom';
import NotFound  from './components/steps/NotFound.js';
import EditTiers  from './components/pages/EditTiers.js';
import Preparations  from './components/pages/Preparations.js';
import Guarantee  from './components/pages/Guarantee.js';
import Privacy  from './components/pages/Privacy.js';
import Blog  from './components/pages/Blog.js';
import Tos  from './components/pages/Tos.js';
import Faq  from './components/pages/Faq.js';
import Home  from './components/pages/Home.js';
import InitReferrer from './components/steps/InitReferrer';
import InitAbandon from './components/steps/InitAbandon';
import Step1Page from './components/steps/step1.js';
import Step2Page from './components/steps/step2.js';
import Step3Page from './components/steps/step3.js';
import Step4Page from './components/steps/step4.js';
import ThankYou  from './components/steps/ThankYou.js';
import PasswordReset  from './components/pages/PasswordReset.js';
import ForgotPassword  from './components/pages/ForgotPassword.js';
import LogIn     from './components/steps/Login.js';
import Register  from './components/User/Register.js';
import StudentDashboard     from './components/dashboards/StudentDashboard.js';
import EditorDashboard      from './components/dashboards/EditorDashboard.js';
import StudentPaperDetails  from './components/dashboards/StudentPaperDetails.js';
import EditorPaperDetails   from './components/dashboards/EditorPaperDetails.js';
import AdminDashboard       from './components/dashboards/AdminDashboard/AdminSubmissions.js';
import AdminDocumentDetails from './components/dashboards/AdminDashboard/AdminDocument.js';
import AdminUserDetails     from './components/dashboards/AdminDashboard/AdminUserDetails.js';
import AdminUsers           from './components/dashboards/AdminDashboard/AdminUsers.js';
import AdminStudents        from './components/dashboards/AdminDashboard/AdminStudents.js';
import AdminAffiliates      from './components/dashboards/AdminDashboard/Affiliates.js';
import AdminCoupons         from './components/dashboards/AdminDashboard/Coupons.js';
import StudentRatingDetails from './components/dashboards/StudentRatingDetails.js';
import EditorRatingDetails  from './components/dashboards/EditorRatingDetails.js';
import scriptLoader from 'react-async-script-loader'
import CouponDetails from './components/dashboards/AdminDashboard/CouponDetails';
import AffiliateDetails from './components/dashboards/AdminDashboard/AffiliateDetails';
injectTapEventPlugin();

class App extends Component {
  render() {
    return (
      <div className="App" className="App-intro">
        <Router>
           {<Switch>
              <Route exact path="/"                         component={Step1Page} />
              <Route path="/get-started"                    component={Step1Page} />
              <Route path="/step2"                          component={Step2Page} Paper={this.props.Paper} />
              <Route path="/step3"                          component={Step3Page} />
              <Route path="/step4"                          component={Step4Page} />
              <Route path="/login"                          component={LogIn} />
              <Route path="/register"                       component={Register} />
              <Route exact path="/studentdashboard"         component={StudentDashboard} />
              <Route path="/studentdashboard/view/:docID"   component={StudentPaperDetails} />
              <Route path="/studentdashboard/rating/:docID" component={StudentRatingDetails} />
              <Route exact path="/editordashboard"          component={EditorDashboard} />
              <Route path="/editordashboard/view/:docID/"   component={EditorPaperDetails} />
              <Route path="/editordashboard/rating/:docID/" component={EditorRatingDetails} />
              <Route path="/thankyou"                       component={ThankYou} />
              <Route exact path="/admindashboard"           component={AdminDashboard} />
              <Route path="/admindashboard/affiliates"      component={AdminAffiliates}/>
              <Route path="/admindashboard/affiliate/:affCode"      component={AffiliateDetails}/>
              <Route path="/admindashboard/coupons"         component={AdminCoupons}/>
              <Route path="/admindashboard/user/:userId"    component={AdminUserDetails}/>
              <Route path="/admindashboard/users"           component={AdminUsers}/>
              <Route path="/admindashboard/students"        component={AdminStudents}/>
              <Route path="/admindashboard/document/:DocId" component={AdminDocumentDetails}/>
              <Route path="/admindashboard/coupon/:couponCode" component={CouponDetails}/>
              <Route path="/forgot"                         component={ForgotPassword}/>
              <Route path="/password-reset/:token"          component={PasswordReset}/>
              <Route path="/preparations"                   component={Preparations}/>
              <Route path="/ref/:refCode"                   component={InitReferrer}/>
              <Route path="/returnToCart/:docId/:refCode" component={InitAbandon}/>
{/*
              <Route path="/edit-tiers"                     component={EditTiers}/>
              
              <Route path="/privacy"                        component={Privacy}/>
              <Route path="/tos"                            component={Tos}/>
              <Route path="/guarantee"                      component={Guarantee}/>
              <Route path="/faq"                            component={Faq}/>
              <Route path="/preparation1.php"               component={Preparations}/>
              <Route path="/faq.php"                        component={Faq}/>
              <Route path="/guarantee1.php"                 component={Guarantee}/>
              <Route path="/signupeditor.php"               component={Home}/>
              <Route path="/editorlevels1.php"              component={EditTiers}/>
              <Route path="/tos1.php"                       component={Tos}/>
              <Route path="/signupstudent.php"              component={Step1Page}/>
              <Route path="/login.php"                      component={LogIn}/>
              <Route path="/mydocuments.php"                component={LogIn}/>
              <Route path="/uploaddoc.php"                  component={LogIn}/>
              <Route exact path="/blog/esl-essay-editing.php"   render={()=> <Blog piece="esl-essay-editing-help"/>} />
              <Route path="/blog/:piece"                    component={Blog} />
              <Route path="/blog/"                    component={Blog} />
              <Route path="/scholarship/2015-outside-scholarship.php" component={Home}/>
              <Route path="/scholarship/proofread-the-paper-2016.php" component={Home}/>

*/}
           </Switch>}
        </Router>
      </div>
    );
  }
}
  // <Route exact path="*"                              component={NotFound} />
// export default App;
export default scriptLoader(
  [
    '/cloudflare/jquery.min.js',
    '/cloudflare/marked.min.js'
  ]
)(App)



// WEBPACK FOOTER //
// ./src/App.js